<app-spinner-overlay></app-spinner-overlay>
<div mat-dialog-title>Assegna Stakeholder</div>
<div class="cont-box-categorie">
  <!-- CATEGORIE INTERNE -->
  <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
    <div class="cont-titolo">
      <mat-label class="titolo">Stakeholder Interni</mat-label>
    </div>
    <div class="list">
      <ng-scrollbar>
        @for (categoria of categoriaSHInterni; track $index) {
          <section>
            <mat-checkbox
              [(ngModel)]="categoria.selected"
              color="primary"
              [disabled]="data.disabled ?? false"
            >
              <mat-label class="truncate">{{ categoria.titolo }}</mat-label>
            </mat-checkbox>
          </section>
        }
      </ng-scrollbar>
    </div>
  </div>

  @if (data.iroType === 'impatti') {
    <!-- CATEGORIE ESTERNE -->
    <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
      <div class="cont-titolo">
        <mat-label class="titolo">Stakeholder Esterni</mat-label>
      </div>
      <div class="list">
        <ng-scrollbar>
          @for (categoria of categoriaSHEsterni; track $index) {
            <section>
              <mat-checkbox
                [(ngModel)]="categoria.selected"
                color="primary"
                [disabled]="data.disabled ?? false"
              >
                <mat-label class="truncate">{{ categoria.titolo }}</mat-label>
              </mat-checkbox>
            </section>
          }
        </ng-scrollbar>
      </div>
    </div>
  }
</div>
<footer mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div *ngIf="!data.disabled">
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</footer>
